import { EVENT_CATEGORIES, sortCategories } from '../../lib/eventCategories'

/** Checkbox per event category (canonical order). Controlled; `onChange`
 *  gets the new selection in canonical order. */
export function EventCategoryChecklist({
  value,
  onChange,
  disabled = false,
  label = 'Event categories',
}: {
  value: string[]
  onChange: (next: string[]) => void
  disabled?: boolean
  label?: string
}) {
  const toggle = (cat: string) =>
    onChange(sortCategories(value.includes(cat) ? value.filter((c) => c !== cat) : [...value, cat]))
  return (
    <div role="group" aria-label={label} className="grid grid-cols-2 gap-x-6 gap-y-1.5 sm:grid-cols-3">
      {EVENT_CATEGORIES.map((c) => (
        <label key={c.value} className="flex cursor-pointer items-center gap-2.5 text-sm text-ostrel-ink">
          <input
            type="checkbox"
            checked={value.includes(c.value)}
            disabled={disabled}
            onChange={() => toggle(c.value)}
            className="h-3.5 w-3.5 accent-ostrel-gold"
          />
          {c.label}
        </label>
      ))}
    </div>
  )
}
